import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false,
  adsById: null
};


export default function initial_import(state = initialState, action) {
  switch (action.type) {
    case types.SET_INITIAL_IMPORT_FILE:
      return {
        ...state,
        initial_import_table: action.payload
      };
    case types.SET_INITIAL_IMPORT_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
}
